<template lang="pug">
  transition(name="fade")
    .modal-container(v-if="visible")
      .modal-bg(@click="hide")
      .modal
        button.close(@click="hide")
          span.btn-close X
        slot
</template>

<script>

export default {
  props:{
    visible:{
      type:Boolean,
      default(){
        return false;
      },
    }
  },
  methods:{
    hide(){
      this.$emit('hide', true)
    }
  }
}
</script>

<style lang="scss">
  @import "../assets/css/global";

  .modal-container{
    .modal-bg{
      position:fixed;
      top:0;
      bottom:0;
      left:0;
      right:0;
      height:100%;
      width:100%;
      background:rgba(lighten(black, 30%), 0.7);

    }
    display: flex;
    justify-content: center;
    align-items: center;
    position:fixed;
    top:0;
    bottom:0;
    left:0;
    right:0;
    height:100%;
    width:100%;
    z-index:1000;
    overflow: hidden;
    .modal{
      position:relative;
      cursor:default;
      width:50%;
      height:50%;
      @include mobile{
        width:75%;
        height:80%;
      }
      background:white;
      // box-shadow: 0px 0px 15px rgba(10, 26, 45, 0.9);
      border:4px solid black;
      .close{
        position:absolute;
        color:rgba(black, 0.8);
        top:5px; 
        right:10px;
        cursor:pointer;
        z-index: 200;
        .btn-close{
          font-family: $font-2;
          font-size: 1.5rem;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// Modal.vue?3938276b